module.exports = __webpack_public_path__ + "static/media/audio-button.eb109daf.svg";